/* istanbul ignore file */
/**
 * Drawer component theme configuration.
 */

export const drawer = {
  root: {
    background: '{overlay.modal.background}',
    borderColor: '{overlay.modal.border.color}',
    color: '{overlay.modal.color}',
    shadow: '{overlay.modal.shadow}',
  },
  header: {
    padding: '20px 12px 24px 32px',
  },
  title: {
    fontSize: '16px',
    fontWeight: '400',
  },
  content: {
    padding: '0px 32px 0px 32px',
  },
};
